function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8080",
  transform: "translate(-428 -171)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 5",
  cx: 70,
  cy: 70,
  r: 70,
  transform: "translate(428 171)",
  fill: "#e8f6f4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-attach-money",
  d: "M500.186 235.75c-10.847-2.82-14.335-5.734-14.335-10.274 0-5.208 4.826-8.84 12.9-8.84 8.506 0 11.659 4.062 11.946 10.035h10.56c-.337-8.219-5.35-15.771-15.337-18.206V198h-14.335v10.321c-9.27 2.007-16.725 8.028-16.725 17.25 0 11.039 9.127 16.529 22.46 19.735 11.946 2.867 14.335 7.072 14.335 11.516 0 3.3-2.341 8.553-12.9 8.553-9.844 0-13.714-4.4-14.24-10.035H474c.573 10.465 8.41 16.342 17.585 18.3v10.372h14.335v-10.274c9.318-1.768 16.725-7.168 16.725-16.963-.001-13.575-11.612-18.206-22.459-21.025z",
  fill: "#a1dbd3"
}));
const SvgDollarIconCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 140 140"
}, props), _ref);
export default SvgDollarIconCircle;